/**
 * Corporate Testimonial Component
 * Uses Owl Carousel 2 to create testimonial sliders with previews
 */
(function() {
    // Component implementation
    const CorporateTestimonial = {
        init: function() {
            const $ = jQuery;
            
            // Find all testimonial slider components on the page
            $('.component__corporate_testimonial').each(function() {
                const $container = $(this).find('.owl-carousel');
                const containerId = $container.attr('id');
                const duration = $container.attr('data-autoplay-duration');
                
                // Initialize this specific testimonial slider
                CorporateTestimonial.initSlider($container, containerId, duration);
            });
        },
        
        initSlider: function($container, containerId, duration = 3000) {
            const $ = jQuery;
            const $customDots = $('#' + containerId + '-dots');
            let totalSlides = $container.find('.testimonial-slide').length;
            
            // Initialize Owl Carousel
            $container.owlCarousel({
                loop: false,
                margin: 0,
                center: true,
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                autoHeight: false,
                autoplay: true,
                autoplayTimeout: parseInt(duration),
                nav: false,
                dots: false,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
                items: 1,
                responsive: {
                    0: {
                        autoHeight: true
                    },
                    1024: {
                       autoHeight: false,
                    }
                }
            });
            
            // Function to start progress bar animation
            function startProgressBar(activeIndex) {
                // Reset all progress bars
                $customDots.find('.progress-bar__bar').css({
                    'width': '0%',
                    'transition': 'none'
                });
                
                // Start animating the active progress bar
                const $activeBar = $customDots.find('button').eq(activeIndex).find('.progress-bar__bar');
                
                // Use a small timeout to ensure the reset has taken effect
                setTimeout(function() {
                    $activeBar.css({
                        'width': '100%',
                        'transition': `width ${parseInt(duration)}ms linear`
                    });
                }, 50);
            }
            
            // Add click handlers for custom dots
            $customDots.find('button').on('click', function() {
                const position = parseInt($(this).data('position'));
                $container.trigger('to.owl.carousel', [position, 300]);
                
                // Stop and restart autoplay to reset the timer
                $container.trigger('stop.owl.autoplay');
                $container.trigger('play.owl.autoplay');
            });
            
            // Update active states when slide changes
            $container.on('changed.owl.carousel', function(event) {
                // Remove active class from all dots
                $customDots.find('button').removeClass('active');
                
                // Add active class to current dot
                const currentIndex = event.item.index;
                $customDots.find('button').eq(currentIndex).addClass('active');
                
                // Start progress bar animation for the current slide
                startProgressBar(currentIndex);
            });
            
            // Handle autoplay progression and looping
            $container.on('translated.owl.carousel', function(event) {
                const currentIndex = event.item.index;
                
                // If we're at the last slide, set a timeout to go back to first slide
                if (currentIndex === totalSlides - 1) {
                    setTimeout(function() {
                        $container.trigger('to.owl.carousel', [0, 300]);
                    }, parseInt(duration));
                }
            });
            
            // Handle autoplay start/restart
            $container.on('play.owl.autoplay', function(event) {
                const currentIndex = $container.find('.owl-item.active').index();
                startProgressBar(currentIndex);
            });
            
            // Set initial active state and start progress
            setTimeout(function() {
                const initialIndex = $container.find('.owl-item.active').index() || 0;
                $customDots.find('button').eq(initialIndex).addClass('active');
                startProgressBar(initialIndex);
            }, 100);
            
            // Handle window resizing
            $(window).on('resize', function() {
                setTimeout(function() {
                    $container.trigger('refresh.owl.carousel');
                }, 200);
            });
        }
    };

    // Initialize on document ready
    jQuery(document).ready(function() {
        CorporateTestimonial.init();
    });
    
    // Make available globally if needed
    window.CorporateTestimonial = CorporateTestimonial;
})();